import * as React from "react";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";

function CustomButton({ onClick, children }) {
  const handleClick = () => {
    console.log("Handle Click", onClick);
  };
  return (
    <Stack direction="row" spacing={2}>
      <Button variant="contained" endIcon={<SendIcon />} onClick={onClick}>
        {children}
      </Button>
    </Stack>
  );
}

export default CustomButton;
